import React, { useState, useEffect } from "react";
import Progress from "react-circle-progress-bar";
import "./Statns4.css";

const AfficheProgress = ({ une_donnee }) => {
  const [initial, setInitial] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitial(une_donnee?.taux || 0);
    }, 100);

    return () => clearTimeout(timer);
  }, [une_donnee?.taux]);

  return (
    <div className="d-flex justify-content-center">
      <Progress
        progress={initial}
        subtitle={une_donnee?.Matiere || ""}
        strokeWidth={2}
        transitionDuration={0.7}
      />
    </div>
  );
};

export default AfficheProgress;
